import axios from "axios"

import { toast } from "react-toastify"
//apply base url for axios
const API_URL = process.env.REACT_APP_BASE_URL

const axiosApi = axios.create({
  baseURL: API_URL,
  // headers,
  validateStatus: function (status) {
    return status == 200
  },
})

function errorResponseHandler(error) {
  if (error) {
    if (error.response.status === 403) {
      localStorage.removeItem("authUser")
      window.location.href = "/login"
      return Promise.reject(error)
    } else if (error.response.status >= 400 && error.response.status < 500) {
      if (
        error.response.status >= 401 &&
        error?.response?.data?.message === "Bad credentials"
      ) {
        const renderHTMLContent = () => {
          const htmlContent =
            "ログインできませんでした。<br /> メールアドレスもしくはパスワードをもう一度ご確認ください"
          return { __html: htmlContent }
        }
        // eslint-disable-next-line react/react-in-jsx-scope
        toast.error(<div dangerouslySetInnerHTML={renderHTMLContent()} />)
      }
    }
  } else {
    localStorage.removeItem("authUser")
    window.location.href = "/login"
    return Promise.reject(error)
  }
}

axiosApi.interceptors.response.use(
  response => response,
  error => errorResponseHandler(error)
)

export async function auth(url, data) {
  try {
    return await axiosApi.post(`${API_URL}${url}`, data)
  } catch (error) {
    console.log("error>>>")
    console.log(error)
  }
}

export async function get(url, params, config) {
  const token = JSON.parse(localStorage.getItem("authUser"))?.accessToken || ""
  const headers = {
    Authorization: `Bearer ${token}`,
  }
  try {
    return await axios.get(`${API_URL}${url}`, { ...config, params, headers })
  } catch (error) {
    if (error) {
      if (error.response.status === 403) {
        localStorage.removeItem("authUser")
        window.location.href = "/login"
        return Promise.reject(error)
      } else if (error.response.status >= 400 && error.response.status < 500) {
        return Promise.reject(error)
      } else {
        console.log("error", error.response)
      }
    }
  }
}

export async function post(url, data, config) {
  try {
    const token =
      JSON.parse(localStorage.getItem("authUser"))?.accessToken || ""
    const headers = {
      Authorization: `Bearer ${token}`,
    }
    return await axios.post(`${API_URL}${url}`, data, { ...config, headers })
  } catch (error) {
    console.log("error", error.response)
    if (error) {
      if (error.response.status === 403) {
        localStorage.removeItem("authUser")
        window.location.href = "/login"
        return Promise.reject(error)
      } else if (error.response.status >= 400 && error.response.status < 500) {
        return Promise.reject(error)
      } else {
        console.log("error", error.response)
      }
    }
  }
}

export async function put(url, data, config) {
  try {
    const token =
      JSON.parse(localStorage.getItem("authUser"))?.accessToken || ""
    const headers = {
      Authorization: `Bearer ${token}`,
    }
    return await axios.put(`${API_URL}${url}`, data, { ...config, headers })
  } catch (error) {
    if (error) {
      if (error.response.status === 403) {
        localStorage.removeItem("authUser")
        window.location.href = "/login"
        return Promise.reject(error)
      } else if (error.response.status >= 400 && error.response.status < 500) {
        return Promise.reject(error)
      } else {
        console.log("error", error.response)
      }
    }
  }
}

export async function patch(url, data, config) {
  try {
    const token =
      JSON.parse(localStorage.getItem("authUser"))?.accessToken || ""
    const headers = {
      Authorization: `Bearer ${token}`,
    }
    return await axios.patch(`${API_URL}${url}`, data, { ...config, headers })
  } catch (error) {
    if (error) {
      if (error.response.status === 403) {
        localStorage.removeItem("authUser")
        window.location.href = "/login"
        return Promise.reject(error)
      } else if (error.response.status >= 400 && error.response.status < 500) {
        return Promise.reject(error)
      } else {
        console.log("error", error.response)
      }
    }
  }
}

export async function del(url, data, config) {
  try {
    const token =
      JSON.parse(localStorage.getItem("authUser"))?.accessToken || ""
    const headers = {
      Authorization: `Bearer ${token}`,
    }
    return await axios.delete(`${API_URL}${url}`, {
      ...config,
      headers,
      data: data,
    })
  } catch (error) {
    if (error) {
      if (error.response.status === 403) {
        localStorage.removeItem("authUser")
        window.location.href = "/login"
        return Promise.reject(error)
      } else if (error.response.status >= 400 && error.response.status < 500) {
        return Promise.reject(error)
      } else {
        console.log("error", error.response)
      }
    }
  }
}
